import CanvasDrawerLabel from './CanvasDrawerLabel';
import compose from 'recompose/compose';
import withProps from 'recompose/withProps';
import withHandlers from 'recompose/withHandlers';
import upperFirst from 'lodash/upperFirst';
import withProductCustomisation from '../../../hocs/withProductCustomisation';
import { getDrawerId } from '../helpers';
import { withModel } from '../../../data-providers/model';
import { replaceCanvasText } from '../../Canvas/helpers';

const enhance = compose(
  withProductCustomisation,
  withModel,
  withProps(props => {
    const drawerId = getDrawerId(props.drawer, props.index);
    const characterLimit = props.drawer.sliceType === 'inscription' ? 17 : 30;
    return {
      drawerId,
      isOpen: drawerId === props.activeDrawer,
      completedTitle: upperFirst(replaceCanvasText(props.drawer.primary.tabCompleteTitle, props, characterLimit)),
      title: upperFirst(replaceCanvasText(props.drawer.primary.tabDefaultText, props)),
      subtitle: replaceCanvasText(props.drawer.primary.tabSubtitle, props),
      isDrawerComplete: props.completedDrawers.includes(drawerId),
    };
  }),
  withHandlers({
    onClick: props => () => props.onToggleDrawer(props.drawerId),
  }),
);

export default enhance(CanvasDrawerLabel);



// WEBPACK FOOTER //
// ./src/client/js/view/components/CanvasDrawers/CanvasDrawerLabel/index.js